import { render, staticRenderFns } from "./GraficoPerfilLoja.vue?vue&type=template&id=bfb30d04&scoped=true"
import script from "./GraficoPerfilLoja.vue?vue&type=script&lang=js"
export * from "./GraficoPerfilLoja.vue?vue&type=script&lang=js"
import style0 from "./GraficoPerfilLoja.vue?vue&type=style&index=0&id=bfb30d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb30d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
